// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import {
	Breadcrumb,
	Button,
	Card,
	Col,
	Offcanvas,
	Row,
	Tab
} from 'react-bootstrap';

// import custom components
import OffcanvasAddUtilisateurForm from '../add-new-utilisateur/OffcanvasAddUtilisateurForm';

// import sub components
import UtilisateursListItems from './UtilisateursListItems';
import UtilisateurService from '../../services/UtilisateurService';

const Utilisateurs = () => {
	const [utilisateurs, setUtilisateurs] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		UtilisateurService.getAllUtilisateurs().then((response) => {
			setUtilisateurs(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Utilisateurs{' '}
									<span className="fs-5 text-muted">
										{' '}
										({utilisateurs.length})
									</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">Accueil</Breadcrumb.Item>
									<Breadcrumb.Item active>Utilisateurs</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<Button onClick={handleShow}>Ajouter un utilisateur</Button>
									<Offcanvas
										show={show}
										onHide={handleClose}
										placement="end"
										name="end"
										style={{ width: '600px' }}
									>
										<Offcanvas.Header closeButton>
											<Offcanvas.Title as="h3">
												Enregistrer un utilisateur
											</Offcanvas.Title>
										</Offcanvas.Header>
										<Offcanvas.Body className="pt-0">
											<OffcanvasAddUtilisateurForm onClick={handleClose} />
										</Offcanvas.Body>
									</Offcanvas>
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* utilisateurs in list view */}
								<UtilisateursListItems />
								{/* end of utilisateurs in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Utilisateurs;
